import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useAuth } from '../../hooks/useAuth';
import LoadingScreen from './LoadingScreen';

export default function AppShell() {
  const { isLoading, user } = useAuth();
  const [isReady, setIsReady] = useState(false);
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith('/admin/');

  useEffect(() => {
    // Only show initial loading state briefly
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  // Show loading state during initial load
  if (isLoading || !isReady) {
    return <LoadingScreen message="Loading..." />;
  }

  // Show security message and redirect when session is terminated
  if (!user) {
    // Redirect to login page after a short delay
    useEffect(() => {
      const timer = setTimeout(() => {
        window.location.href = '/login';
      }, 1500);
      
      return () => clearTimeout(timer);
    }, []);
    
    return <LoadingScreen message="Session Terminated - Redirecting to Login" />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <div className="flex flex-1 h-[calc(100vh-5rem)] mt-20 pt-2 sm:pt-0">
        <Sidebar />
        <main className="flex-1 overflow-auto w-full lg:ml-64">
          <div className="p-4">
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}
